<template>
  <div class="container">
    <headers></headers>
    <right></right>
    <scrollpage></scrollpage>

    <div class="w box_sizing width_box my_wrap">
      <div class="left_position">
        <left></left>
      </div>

      <div class="banner_detail box_sizing">
        <div class="mokao_list_header box_sizing flex_box flex_align_center flex_justify_between">
          <div class="mokao_list_header_left flex_box flex_align_center">
            <div class="biao">{{ name }}</div>
            <div class="number">总数：{{ list.length }}</div>
          </div>
          <div class="mokao_list_header_right flex_box flex_align_center">
            <el-input
              v-model="searchText"
              clearable
              placeholder="搜索试卷标题"
              size="small"
              class="mokao_search_input"
              @clear="onSearchClear"
            ></el-input>
          </div>
        </div>
        <!-- <div
          class="listTitle flex_box flex_justify_between flex_align_center box_sizing"
        >
          <div class="flex_box flex_align_center">
            <div class="biao">{{name}}</div> -->
            <!-- <div class="number">总体数：330</div>
            <div class="number">已练习：220</div> -->
          <!-- </div>
          <img src="../assets/images/guanbi.png" alt="" style="width: 16px" />
        </div> -->
        <!-- <div class="flex_box flex_align_center box_sizing statusList">
          <div
            class="statusone"
            :class="current == 0 ? 'activeone' : ''"
            @click="current = 0"
          >
            按更新
          </div>
          <div
            class="statusone"
            :class="current == 1 ? 'activeone' : ''"
            @click="current = 1"
          >
            按完成人数
          </div>
          <div
            class="statusone"
            :class="current == 2 ? 'activeone' : ''"
            @click="current = 2"
          >
            只看未做
          </div>
        </div> -->
        <div
          class="flex_box flex_align_center flex_justify_between mokaoone box_sizing"
          @click="toProduce(item.id,item.title)"
          v-for="(item, index) in filteredList"
          :key="index"
        >
          <div>{{item.title}}</div>
          <div class="flex_box flex_align_center people">
            <div>完成人数：{{item.num}}人</div>
            <div>{{item.createtime}}</div>
          </div>
        </div>
      </div>
    </div>

    <footers></footers>
  </div>
</template>

<script>
import headers from "@/components/headers";
import footers from "@/components/footders";
import left from "@/components/left";
import right from "@/components/right";
import scrollpage from "@/components/scrollpage";
var _this;
export default {
  components: {
    headers,
    footers,
    left,
    right,
    scrollpage,
  },
  computed: {
    /**
     * 试卷列表（支持搜索过滤）。
     * @description 按 title 进行关键词模糊匹配过滤
     * @returns {Array} 过滤后的列表
     */
    filteredList() {
      const kw = String(this.searchText || "").trim().toLowerCase();
      if (!kw) return this.list;
      return (this.list || []).filter((item) => {
        const title = (item && item.title) ? String(item.title) : "";
        return title.toLowerCase().includes(kw);
      });
    },
  },
  data() {
    return {
      current: 0,
      mokao: [1, 1, 1, 1],
      list: [],
      id: "",
      name: '',
      searchText: "",
    };
  },
  created() {
    _this = this;
    _this.getParams();
  },
  mounted() {},
  methods: {
    /**
     * 清空搜索关键词。
     * @returns {void}
     */
    onSearchClear() {
      this.searchText = "";
    },
    // 获取试卷列表
    getList() {
        var params = {
            type: _this.id,
        };
        _this.$axios
            .post("exam.exam/getList", params)
            .then((res) => {
                console.log('模考试卷列表：：：：：：',res);
                if (res.code == 1) {
                    _this.list = res.data;
                } else {
                    _this.$message.error(res.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    },

    // 获取传递过来的参数
    getParams() {
        _this.id = _this.$route.query.id;
        _this.name = _this.$route.query.name ? _this.$route.query.name : '仿真模考';
        _this.getList();
    },

    /**
     * 跳转到模考介绍页（新标签页打开）
     * @param {string|number} id 试卷ID
     * @param {string} title 试卷标题
     * @returns {void} 无返回值
     */
    toProduce(id,title) {
      if(!localStorage.getItem("token")) {
        this.$message.error("请登录后再进行答题");return
      } else {
        const routeUrl = _this.$router.resolve({
          name: "produce",
          query: {
            id: id,
            name: title,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>


<style>
.banner_detail {
  width: 100%;
  padding: 34px 35px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 1);
}
.mokao_list_header {
  width: 100%;
  padding: 12px 20px;
  background: #f9f9f9;
  border-radius: 10px;
  margin-bottom: 10px;
}

.mokao_search_input {
  width: 220px;
}
.listTitle {
  width: 951px;
  height: auto;
  padding: 11px 20px;
  background: #f9f9f9;
  opacity: 1;
}
.biao {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 30px;
  color: #06121e;
  margin-right: 20px;
}
.number {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #8c9198;
  margin-right: 20px;
}
.statusList {
  padding: 28px 0;
}
.statusone {
  width: 111px;
  height: 30px;
  border: 1px solid #8c9198;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  margin-right: 32px;
  color: #8c9198;
}
.activeone {
  color: #f6704b;
  border: 1px solid #f6704b;
}
.mokaoone {
  font-size: 14px;
  font-weight: 500;
  padding: 20px;
  color: #06121e;
  border-bottom: 1px solid #f7f8fa;
  cursor: pointer;
}
.people {
  font-size: 12px;
}
.people div {
  margin-left: 20px;
  font-weight: 500;
}
</style>
